import ProviderUtils from "../utils/provider.utils";

// Используем require.context для автоматического импорта всех файлов с расширением .jsx и .tsx
const context = require.context("./", true, /\.(jsx|tsx)$/);
const resolvedComponents = ProviderUtils.resolveComponents(context);

export default resolvedComponents;
